import { IServiceResponse } from "@/core/model/rest/IServiceResponse";
import IParamServices from "../IParamServices";
import BaseService from "../base/BaseService";
import { IEmployee } from "@/core/model/sys/IEmployee";
import { IUser } from "@/core/model/sys/IUser";
import {v4 as uuidv4} from 'uuid';


export default class EmployeService extends BaseService
{
  constructor(param: IParamServices)
  {
    super(param);
  }   
  public getEmployee():IEmployee 
    {
      const user:IUser = this.getUser();
        return {
        Gid: uuidv4(),
        Code:'',	
        Name:'',	
        LastName:'',	
        MiddleName:'',	
        Phone:'',	
        Comments:'',	
        CreatedBy:0,
        CreatedTime:new Date(),
        ModifiedBy:0,
        ModifiedTime:new Date(),
        Private:false,
        Active:true,
        User:user,
        InviteGid:null
        };
  }
  public getUser():IUser 
    {
        return {
            Gid: uuidv4(),
            UserName:'',
            Password:'',
            Email:'',
            Comments:'',
            Photo:'',
            Theme:'',
            Language:'',
            IsRoot:true,
            IsVisible:true,
            Private:true,
            Version:0,
            Active:true
        };
  }
  public async ListEmployees():Promise<IEmployee[]>
  {
    const employees = Array<IEmployee>();
    const response:IServiceResponse = await this.Get('IndexEmployee/ListEmployees',null,null,null,true,false,null);  
    if(response.Response)
    {
      for (const element of response.Response)
      {
        employees.push({...element});  
      }
    }    
    return employees;
  }
  public async InviteAdmin(values:any):Promise<any>
  {    
    const response:IServiceResponse = await this.Post('IndexEmployee/InviteAdmin',{
      Email:values.email,
      IsRoot:true
    },null,null,null,true,false,null);      
    return response && response.Response? response.Response.Result:null;
  }
  public async ReInviteAdmin(gid:string):Promise<any>
  {    
    const response:IServiceResponse = await this.Post('IndexEmployee/ReInviteAdmin',{
      Gid:gid
      
    },null,null,null,true,false,null);      
    return response && response.Response? response.Response:null;
  }
  public async GetInvite(id:string):Promise<any>
  {    
    const response:IServiceResponse = await this.Get('IndexEmployee/GetInvite/' + id ,
      null,null,null,true,false,null);           
    return response && response.Response? response.Response:null;
  }
  public async SaveEmployee(employee:any,inviteId:string|null) : Promise<IEmployee>
  {
    const factory = this.getFactory();
    const cservice = factory.getCService;                
    const newEmployee:IEmployee = this.getEmployee();
    const isNew = inviteId;
    let response:IServiceResponse;
    if(isNew)
    {
      newEmployee.InviteGid = inviteId;      
      newEmployee.Code = "";
      newEmployee.Name = employee.nombre;
      newEmployee.LastName = employee.paterno;
      newEmployee.MiddleName = employee.materno;
      newEmployee.Phone = employee.phone;
      newEmployee.Comments = employee.comments;
      newEmployee.User.UserName = employee.username;
      newEmployee.User.Email = employee.email;
      newEmployee.User.Password = cservice.ToMD5(employee.clave);
      response = await this.Post('IndexEmployee/SaveNewEmployee',newEmployee,null,null,null,true,false,null);
    }
    else
    {
      newEmployee.InviteGid = null; 
      newEmployee.Gid = employee.gid;     
      newEmployee.Code = employee.code;
      newEmployee.Name = employee.nombre;
      newEmployee.LastName = employee.paterno;
      newEmployee.MiddleName = employee.materno;
      newEmployee.Phone = employee.phone;
      newEmployee.Comments = employee.comments;
      newEmployee.Active = employee.active;     
      response = await this.Post('IndexEmployee/SaveEmployee',newEmployee,null,null,null,true,false,null);
    }
    newEmployee.Gid = '';
    if(response && response.Response)
    {
      newEmployee.Gid = response.Response.Id;
      if(response.Response.Error)
      {
        newEmployee.Gid = '';
        newEmployee.Active = false;
        newEmployee.Comments = response.Response.Response;
      }
    }
    return newEmployee;
  }
  public async GetInvitedUser():Promise<any>
  {    
    const response:IServiceResponse = await this.Get('IndexEmployee/GetInvitedUser',null,null,null,true,false,null);           
    return response && response.Response? response.Response:null;
  }
}